import React from "react";

import Usaimport from "@/pages/usaimport";
import Usafaq from "@/pages/usafaq";
import Contacts from "@/pages/contacts";

function Usa() {
  


  const SectionIconBoxes = () => {
    return (
      <>
        <div className="relative w-full">
          <img
            src="usai.jpg" // Ensure this image path is correct
            alt="USA Immigration"
            className="h-1/3 w-full object-cover"
          />
          <div className="absolute bottom-5 left-20 text-xl md:text-4xl font-bold text-white drop-shadow-md">
            United States of America
          </div>
        </div>

        <div className="w-full md:w-full xl:mt-32 lg:mt-32 md:mt-20 mt-32 px-5 md:px-20">
          <p className="text-4xl text-[#011473] md:text-6xl font-bold mb-5 text-center">
            Available Visa Options
          </p>

          <div className="container mx-auto mb-10 mt-14">
            <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-6">
              {/* Skilled Migration Visa */}
              <div className="flex flex-col items-center text-center p-2 border shadow-md relative group hover:cursor-pointer transform transition-transform duration-300 rounded-xl hover:scale-105 hover:shadow-xl h-64">
                <img
                  src="/greencard.jpg"
                  alt="Employment based green card"
                  className="w-40 h-40 mb-4 group-hover:opacity-0 transition-opacity duration-300"
                />
                <h2 className="text-xl md:text-xl text-[#011473] font-medium group-hover:opacity-0 transition-opacity duration-300">
                  Employment based green card
                </h2>
                <div className="absolute flex flex-col items-center justify-center inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-lg text-center mb-4">
                    Secure U.S. permanent residency and enjoy a range of privileges typically available to American citizens.
                  </p>
                  <a href="/usa-employment-based-greencard">
                    <button className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors duration-300">
                      Read More
                    </button>
                  </a>
                </div>
              </div>

              {/* Student Visa */}
              <div className="flex flex-col items-center text-center p-8 border shadow-md relative group hover:cursor-pointer transform transition-transform duration-300 rounded-xl hover:scale-105 hover:shadow-xl h-64">
                <img
                  src="/student.jpg"
                  alt="Student Visa"
                  className="w-40 h-40 mb-4 group-hover:opacity-0 transition-opacity duration-300"
                />
                <h2 className="text-xl md:text-xl text-[#011473] font-medium group-hover:opacity-0 transition-opacity duration-300">
                  Student Visa
                </h2>
                <div className="absolute flex flex-col items-center justify-center inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-lg text-center mb-4">
                    Pursue your education in the U.S. through a valid visa, applicable for academic courses, exchange programs, or short-term study programs.
                  </p>
                  <a href="/usa-study-visa">
                    <button className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors duration-300">
                      Read More
                    </button>
                  </a>
                </div>
              </div>

              {/* Visit Visa */}
              <div className="flex flex-col items-center text-center p-2 border shadow-md relative group hover:cursor-pointer transform transition-transform duration-300 rounded-xl hover:scale-105 hover:shadow-xl h-64">
                <img
                  src="/visit.jpg"
                  alt="Visit Visa"
                  className="w-40 h-40 mb-4 group-hover:opacity-0 transition-opacity duration-300"
                />
                <h2 className="text-xl md:text-xl text-[#011473] font-medium group-hover:opacity-0 transition-opacity duration-300">
                  Visit Visa
                </h2>
                <div className="absolute flex flex-col items-center justify-center inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-lg text-center mb-4">
                    Discover the United States—home to a rich cultural heritage, groundbreaking innovations and some of the most awe-inspiring natural landscapes.
                  </p>
                  <a href="/usa-visit-visa">
                    <button className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors duration-300">
                      Read More
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-20 max-w-4xl p-4">
          <h1 className="mb-4 text-3xl font-bold text-[#011473]">
            U.S. Immigrant Visa
          </h1>
          <p className="text-lg text-gray-700">
            The Immigrant Visa is for individuals who wish to settle permanently in the U.S. from Dubai through immigrant investor programs. Unlike non-immigrant visas, an immigrant visa offers the advantage of permanent residency in the United States, allowing you to live and work without the need to return to your home country. This visa provides numerous opportunities, such as access to employment, education and all the benefits available to U.S. residents.
          </p>
        </div>

        <Usaimport />
        <Usafaq />
        <Contacts />
      </>
    );
  };

  return <SectionIconBoxes />;
}

export default Usa;
